import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ExercisePage = lazy(() => import("./ExercisePage"));

const ExercisePageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ExercisePage />
    </Suspense>
  );
};

export default ExercisePageLazy;
